import { useCallback, useEffect, useRef, useState } from 'react';
export function useSendGate() {
    let { extraBlocking = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const [isAutoSavePending, setAutoSavePending] = useState(false);
    const [isCustomPageUploading, setCustomPageUploading] = useState(false);
    const [isAwaitingSend, setIsAwaitingSend] = useState(false);
    const queuedSubmitRef = useRef(null);
    useEffect(()=>{
        return ()=>{
            queuedSubmitRef.current = null;
        };
    }, []);
    const isSendBlocked = isAutoSavePending || isCustomPageUploading || extraBlocking;
    useEffect(()=>{
        if (isSendBlocked) return;
        const queued = queuedSubmitRef.current;
        if (queued == null) return;
        queuedSubmitRef.current = null;
        setIsAwaitingSend(false);
        queued();
    }, [
        isSendBlocked
    ]);
    const submitWhenReady = useCallback((submit)=>{
        if (!isSendBlocked) {
            submit();
            return;
        }
        if (queuedSubmitRef.current != null) return;
        // queue for deferred execution after the gate clears — not a prop mirror, no re-render dodging.
        // eslint-disable-next-line custom/no-useref-for-prop-mirror
        queuedSubmitRef.current = submit;
        setIsAwaitingSend(true);
    }, [
        isSendBlocked
    ]);
    const cancelQueue = useCallback(()=>{
        queuedSubmitRef.current = null;
        setIsAwaitingSend(false);
    }, []);
    return {
        isAwaitingSend,
        submitWhenReady,
        cancelQueue,
        setAutoSavePending,
        setCustomPageUploading
    };
}
